export default __webpack_public_path__ + "static/media/narendra_rangani.39ae31f6.jpeg";